import { useEffect } from 'react';

import type { UseProductsEffectsProps } from '@app/pages/Warehouses/Products/types';

export const useProductsEffects = ({
  onSearchHandler,
  filtersListsHandler,
  onSaveFiltersToStorage,
  syncWarehouseIdSearchParam,
}: UseProductsEffectsProps) => {
  useEffect(() => {
    filtersListsHandler();
  }, [filtersListsHandler]);

  useEffect(() => {
    onSearchHandler();
  }, [onSearchHandler]);

  useEffect(() => {
    onSaveFiltersToStorage();
  }, [onSaveFiltersToStorage]);

  useEffect(() => {
    syncWarehouseIdSearchParam();
  }, [syncWarehouseIdSearchParam]);
};
